export default __webpack_public_path__ + "static/media/x-log.48a68c2c.jpg";